module.exports = __webpack_public_path__ + "img/MY.49809a0e.png";